module.exports = __webpack_public_path__ + "img/tires_rims.965bedd3.svg";